module.exports = __webpack_public_path__ + "img/doc_fill.1ca5d29e.svg";